import { ReferenceAuthorization } from "../interfaces/referenceAuthorization";
import { ReferenceAuthorizationInstruction } from "../interfaces/referenceAuthorizationInstruction";

const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";

const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_API_URL
      : DEV_API_URL;

export const getReferenceAuthorizationBase = async (
  clientID: number,
): Promise<ReferenceAuthorization> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetch(
    `${apiBaseUrl}/api/ReferenceAuthorization/GetReferenceAuthorizationBase/${clientID}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error("Failed to get reference authorization for client.");
  }

  return await response.json();
};

export const getReferenceAuthorizationInstructions = async (
  clientID: number,
  years: number,
): Promise<ReferenceAuthorizationInstruction> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const formData = {
    clientID,
    years,
  };

  const response = await fetch(
    `${apiBaseUrl}/api/ReferenceAuthorization/GetReferenceAuthorizationInstructions`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    },
  );

  if (!response.ok) {
    throw new Error(
      "Failed to get reference authorization instructions for client.",
    );
  }

  return await response.json();
};

export const createReferenceAuthorization = async (
  clientID: number,
): Promise<boolean> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetch(
    `${apiBaseUrl}/api/ReferenceAuthorization/CreateReferenceAuthorization/${clientID}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    throw new Error("Failed to create reference authorization for client.");
  }

  return true;
};

export const updateBaseTextReferenceAuthorization = async (
  clientID: number,
  baseTextKey: keyof ReferenceAuthorization,
  baseText: string,
): Promise<boolean> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const formData = {
    clientID,
    baseTextKey,
    baseText,
  };

  const response = await fetch(
    `${apiBaseUrl}/api/ReferenceAuthorization/UpdateBaseText`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    },
  );

  if (!response.ok) {
    throw new Error("Failed to update reference authorization for client.");
  }

  return true;
};

export const updateInstructionsReferenceAuthorization = async (
  clientID: number,
  baseTextKey: keyof ReferenceAuthorizationInstruction,
  baseText: string,
): Promise<boolean> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const formData = {
    clientID,
    baseTextKey,
    baseText,
  };

  const response = await fetch(
    `${apiBaseUrl}/api/ReferenceAuthorization/UpdateInstruction`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    },
  );

  if (!response.ok) {
    throw new Error(
      "Failed to update reference authorization instruction for client.",
    );
  }

  return true;
};
